import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "wp1200" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "sliderEvent" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1)
const _hoisted_5 = { class: "product-item" }
const _hoisted_6 = { class: "product-item-content" }
const _hoisted_7 = {
  key: 1,
  class: "eventImage relative flex justify-content-center align-items-center"
}
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "time" }
const _hoisted_10 = { class: "city" }
const _hoisted_11 = { class: "primary" }
const _hoisted_12 = { class: "gray" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "font-semibold title"
}
const _hoisted_15 = { class: "clamp" }
const _hoisted_16 = { class: "linkButton" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_arrow-R" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlaceholderImage = _resolveComponent("PlaceholderImage")!
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("event_slider.featured")), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_swiper, {
        breakpoints: _ctx.breakpoints,
        modules: _ctx.modules,
        pagination: { el: 'swiper-pagination', clickable: true }
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, {
              key: event.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_router_link, {
                      to: { name: 'Event', params: { id: event.id } },
                      class: "eventCard"
                    }, {
                      default: _withCtx(() => [
                        (event.image_url)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "eventImage",
                              style: _normalizeStyle({
                  backgroundImage: 'url(' + event.image_url + ')',
                })
                            }, null, 4))
                          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createVNode(_component_PlaceholderImage)
                            ])),
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_CalendarIcon, {
                            date: event.datetime
                          }, null, 8, ["date"]),
                          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$moment(event.datetime).format("DD.MM.yyyy HH:mm")), 1),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(event.city), 1),
                          _createElementVNode("span", _hoisted_11, _toDisplayString(event.venue), 1),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(event.venue_description), 1),
                          _hoisted_13,
                          _createElementVNode("h2", null, _toDisplayString(event.title), 1),
                          (event.canceled_at)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t("widgets.events.canceled")) + ": " + _toDisplayString(event.canceled_reason), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(event.summary), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["breakpoints", "modules"]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_router_link, {
          class: "showAllLink",
          to: { name: 'Events' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("event_slider.all")) + " ", 1),
            _hoisted_17
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}